<mat-toolbar
  class="topbar gap-1.5"
  [class.topbar--with-pos-search]="
    showPosHeaderOps() && isPosWorkspace() && showPosProductSearch()
  "
>
  @if (isPosWorkspace()) {
    @if (!showToggle) {
      <div class="topbar-pos-brand-row">
        <button
          type="button"
          mat-icon-button
          data-overlay-nav-toggle
          class="topbar-pos-brand-row__menu flex justify-center items-center shrink-0"
          (click)="onPosBrandClick()"
          [attr.aria-label]="'shell.openMenuPos' | translate"
          [attr.title]="'shell.openMenuPos' | translate"
        >
          <i class="iconify text-xl! flex" data-icon="solar:hamburger-menu-line-duotone"></i>
        </button>
        @if (!mobileNavOpen && !isPosShell()) {
          <app-branding
            class="topbar-branding topbar-branding--pos"
            [navigable]="false"
          ></app-branding>
        }
        @if (!mobileNavOpen && isPosShell()) {
          <app-branding
            class="topbar-branding topbar-branding--pos topbar-branding--pos-isotype"
            variant="isotype"
            [navigable]="false"
          ></app-branding>
        }
      </div>
    } @else if (isPosShell()) {
      <!-- Shell POS: isotipo en móvil; en inmersivo (sin rail) también en desktop. -->
      <app-branding
        class="topbar-branding topbar-branding--pos topbar-branding--pos-isotype"
        [class.lg:hidden!]="!posImmersive"
        variant="isotype"
        [navigable]="false"
      ></app-branding>
    }
  } @else {
    <!-- Mobile Menu -->
    @if (!showToggle) {
      <button mat-icon-button data-overlay-nav-toggle (click)="toggleMobileNav.emit()" class="flex justify-center items-center">
        <i class="iconify text-xl! flex" data-icon="solar:hamburger-menu-line-duotone"></i>
      </button>
    }
    <!--
      Logo Milinco en topbar móvil.
      Con dock, showToggle=true (sin hamburger) pero la marca sigue siendo necesaria:
      en escritorio vive en el rail; aquí solo ≤lg.
    -->
    <app-branding class="topbar-branding lg:hidden!"></app-branding>
  }

  @if (showShellContext()) {
    <span
      class="hidden sm:inline-flex items-center rounded-full px-3 py-1 text-xs font-medium bg-light-primary text-primary shrink-0 max-w-[220px] truncate"
      [attr.title]="shellContextLabel()"
    >
      {{ shellContextLabel() }}
    </span>
  }

  <app-company-switcher />
  <app-location-switcher />
  <!-- --------------------------------------------------------------- -->

  @if (showPosHeaderOps() && isPosWorkspace() && showPosProductSearch()) {
    <app-pos-header-search
      class="topbar-pos-search"
      [class.topbar-pos-search--shell]="isPosShell()"
    />
  }

  <!-- Shell POS: spacer empuja ops + perfil a la derecha (también en tablet/móvil). -->
  @if (!isPosShell()) {
    <span class="flex-1" aria-hidden="true"></span>
  } @else {
    <span class="topbar-pos-shell-spacer" aria-hidden="true"></span>
  }

  @if (showPosHeaderOps()) {
    @if (isPosWorkspace() && !isPosShell()) {
      <button
        type="button"
        mat-icon-button
        class="topbar-pos-open-tab flex justify-center items-center shrink-0"
        (click)="openPosInNewTab()"
        [attr.aria-label]="'shell.openInNewTab' | translate"
        [matTooltip]="'shell.openInNewTab' | translate"
      >
        <i class="iconify text-xl! flex" data-icon="tabler:external-link" aria-hidden="true"></i>
      </button>
    }
    <app-pos-header-ops class="topbar-pos-ops" />
  }

  <!-- Mobile Menu -->
  @if (!isPosShell()) {
  <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="topbar-app-hide flex lg:hidden! justify-center items-center">
    <i class="iconify text-xl! flex" data-icon="solar:menu-dots-outline"></i>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!-- Collpase bar -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button (click)="toggleCollpase()" class="topbar-app-hide flex lg:hidden! justify-center">
    <i class="iconify text-xl! flex" data-icon="solar:sort-outline"></i>
  </button>
  }
  @if (isCollapse && !isPosShell()) {
  <div class="header-collpase py-2.5 px-4">
    <div class="flex justify-center gap-2.5">
      <!-- --------------------------------------------------------------- -->
      <!-- Notification Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button class="relative flex items-center justify-center" mat-icon-button [matMenuTriggerFor]="notificationmenu"
        [matBadge]="notificationsUnreadCount() > 0 ? notificationsUnreadCount() : null" matBadgeColor="warn"
        matBadgeSize="small" aria-label="Notifications">
        <i class="iconify flex" data-icon="solar:bell-line-duotone"></i>
        @if (notificationsUnreadCount() > 0) {
        <div class="notify">
          <span class="heartbit"></span> <span class="point"></span>
        </div>
        }
      </button>
      <!-- --------------------------------------------------------------- -->
      <!-- Profile Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button
        type="button"
        class="topbar-profile-mobile topbar-profile-mobile--force"
        [matMenuTriggerFor]="profilemenu"
        aria-label="Profile"
      >
        @if (authSession.user()) {
          <span class="topbar-profile-avatar" aria-hidden="true">{{ userInitialsDisplay() }}</span>
        } @else {
          <img
            src="/assets/images/profile/user-1.jpg"
            class="topbar-profile-avatar topbar-profile-avatar--image"
            width="36"
            height="36"
            alt=""
          />
        }
      </button>
    </div>
  </div>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown (menú siempre declarado: refs del collapse) -->
  <!-- --------------------------------------------------------------- -->
  @if (!isPosShell()) {
  <button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications"
    [matBadge]="notificationsUnreadCount() > 0 ? notificationsUnreadCount() : null" matBadgeColor="warn"
    matBadgeSize="small" class="topbar-notifications flex items-center justify-center">
    <i class="iconify text-xl! flex" data-icon="solar:bell-line-duotone"></i>
  </button>
  }
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow" (opened)="onNotificationsMenuOpened()">
    <div class="flex items-center justify-between px-7.5 py-4">
      <h6 class="text-base font-semibold">{{ 'header.notifications.title' | translate }}</h6>
      @if (orderNotificationItems().length > 0) {
      <span class="bg-primary text-[var(--mat-sys-on-primary)] px-2 py-1 font-medium rounded text-xs">
        {{ 'header.notifications.newCount' | translate:{ count: orderNotificationItems().length } }}
      </span>
      }
    </div>

    @for(notification of orderNotificationItems(); track notification.id) {
    <button mat-menu-item class="px-7.5! py-3!" (click)="onNotificationClick(notification)">
      <div class="flex gap-4 items-center">
        <span
          class="shrink-0 text-primary bg-light-primary rounded-full size-12! flex items-center justify-center">
          <i-tabler
            [name]="notification.kind === 'service_request' ? 'clipboard-list' : 'receipt'"
            class="text-xl! flex"
          ></i-tabler>
        </span>
        <div class="w-full">
          <div class="flex items-center justify-between w-full">
            <h5 class="text-sm font-semibold">
              @if (notification.kind === 'service_request') {
                {{ 'header.notifications.serviceRequestReceived.title' | translate:{ number: notification.number } }}
              } @else {
                {{ 'header.notifications.orderReceived.title' | translate:{ number: notification.number } }}
              }
            </h5>
            <span class="block text-xs">{{ notification.time }}</span>
          </div>
          <span class="block text-truncate text-xs">
            @if (notification.kind === 'service_request') {
              {{ 'header.notifications.serviceRequestReceived.subtitle' | translate:{ name: notification.customerName || '' } }}
            } @else {
              {{ 'header.notifications.orderReceived.subtitle' | translate }}
            }
          </span>
        </div>
      </div>
    </button>
    } @empty {
    <div class="px-7.5 py-6 text-center text-xs text-muted">
      {{ 'header.notifications.empty' | translate }}
    </div>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--
    Perfil móvil: botón nativo (no mat-icon-button). Material pisa color/tamaño
    del avatar con utilidades Tailwind y en Android queda “GA” plano e inclickable.
  -->
  <button
    type="button"
    class="topbar-profile-mobile"
    [matMenuTriggerFor]="profilemenu"
    aria-label="Profile"
  >
    @if (authSession.user()) {
      <span class="topbar-profile-avatar" aria-hidden="true">{{ userInitialsDisplay() }}</span>
    } @else {
      <img
        src="/assets/images/profile/user-1.jpg"
        class="topbar-profile-avatar topbar-profile-avatar--image"
        width="36"
        height="36"
        alt=""
      />
    }
  </button>

  <button
    type="button"
    class="topbar-profile-desktop"
    [matMenuTriggerFor]="profilemenu"
    aria-label="Profile"
  >
    @if (authSession.user()) {
      <span class="topbar-profile-avatar" aria-hidden="true">{{ userInitialsDisplay() }}</span>
      @if (toolbarUserLabel(); as userLabel) {
        <span class="topbar-profile-desktop__label">{{ userLabel }}</span>
      }
    } @else {
      <img
        src="/assets/images/profile/user-1.jpg"
        class="topbar-profile-avatar topbar-profile-avatar--image"
        width="36"
        height="36"
        alt=""
      />
    }
    <i data-icon="solar:alt-arrow-down-bold" class="iconify topbar-profile-desktop__chevron" aria-hidden="true"></i>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd profile-menu-panel" xPosition="before">
    <div class="profile-menu-panel__identity">
      @if (authSession.user(); as sessionUser) {
      <div class="profile-menu-panel__avatar" aria-hidden="true">
        {{ userInitialsDisplay() }}
      </div>
      <div class="profile-menu-panel__meta">
        <h6 class="profile-menu-panel__name">
          <span class="truncate">{{ sessionUser.name }}</span>
          @if (sessionRoleBadge(); as role) {
          <span class="profile-menu-panel__role">{{ role }}</span>
          }
        </h6>
        <span class="profile-menu-panel__email">{{ sessionUser.email }}</span>
        @if (primaryCompanyDisplay(); as companyName) {
        <span class="profile-menu-panel__company">{{ companyName }}</span>
        }
      </div>
      } @else {
      <img
        src="/assets/images/profile/user-1.jpg"
        class="profile-menu-panel__avatar object-cover"
        width="44"
        height="44"
        alt=""
      />
      <div class="profile-menu-panel__meta">
        <h6 class="profile-menu-panel__name">—</h6>
        <span class="profile-menu-panel__email">—</span>
      </div>
      }
    </div>

    @if (isPosShell()) {
      <button mat-menu-item type="button" (click)="exitPosToMilinco()">
        <i-tabler name="arrow-bar-to-left" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
        <span class="profile-menu-panel__item-label">{{ 'sidebar.posNav.backToMilinco' | translate }}</span>
      </button>
      <mat-divider></mat-divider>
    }
    @if (showWorkspaceSwitcher()) {
      <button mat-menu-item type="button" (click)="openWorkspacePicker()">
        <i-tabler name="building-store" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
        <span class="profile-menu-panel__item-label">{{ 'header.profile.menu.switchBusiness' | translate }}</span>
      </button>
      <mat-divider></mat-divider>
    }
    @for (profile of profileMenuItems(); track profile.id) {
      @if (!profile.logout) {
      <button
        mat-menu-item
        [routerLink]="profile.link"
        [class.profile-menu-panel__item--active]="profile.active"
      >
        <i-tabler [name]="profile.icon" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
        <span class="profile-menu-panel__item-label">{{ profile.titleKey | translate }}</span>
      </button>
      }
    }

    <mat-divider></mat-divider>

    @if (showAppVersion()) {
      <div class="profile-menu-panel__version" title="Versión de la aplicación">
        v{{ appVersionLabel }}
      </div>
    }

    <button mat-menu-item class="profile-menu-panel__sign-out" (click)="signOut()">
      <i-tabler name="logout" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
      <span class="profile-menu-panel__item-label">{{ 'header.profile.menu.signOut' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
